import { useEffect } from 'react';
/* eslint-disable no-undef */

export function usePageViewTracking(page_name) {
  useEffect(() => {
    if (window.analytics) {
      window.analytics.track('Page Viewed', {
        page_name,
      });
    }
  }, []);
}
